// extracted by mini-css-extract-plugin
export default {"slider":"NftCardBackSlider_slider__CNnwQ"};